export default function CenterLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className='flex h-full w-full justify-center p-4'>
      <div className={`w-full md:max-w-[1280px]`}>
        {children}
      </div>
    </div>
  );
}